// @flow
import React, { type Node } from 'react';
import PartnerComment from 'components/partner/PartnerComment';
import type { Comment, SubCommentsMap } from 'store/modules/partners';
import { numberWithCommas } from 'lib/common';
import { redirectToLogin } from 'lib/sso';

import './PartnerComments.scss';

type Props = {
  commentInput: Node,
  commentsCount: number,
  comments: ?(Comment[]),
  onReply: (text: string, replyTo: ?string, parentId?: ?string) => Promise<*>,
  onReadReplies: (commentId: string, parentId?: ?string) => Promise<*>,
  subCommentsMap: SubCommentsMap,
  logged: boolean,
  username: ?string,
  onOpenRemove: (payload: { commentId: string, parentId: ?string }) => any,
  onEditComment: ({
    commentId: string,
    parentId: ?string,
    text: string,
  }) => any,
  currentPath: string,
};

const PartnerComments = ({
  commentInput,
  comments,
  onReply,
  onReadReplies,
  subCommentsMap,
  logged,
  username,
  onOpenRemove,
  onEditComment,
  commentsCount,
  currentPath,
}: Props) => (
  <div className="PartnerComments">
    <h3 className="title">
      댓글 <span className="count">{numberWithCommas(commentsCount)}</span>
    </h3>
    <div className="comment-input">{commentInput}</div>
    {!logged && (
      <div className="ask-login">
        <span onClick={redirectToLogin} style={{ cursor: 'pointer', textDecoration: 'underline' }}>로그인</span> 후 댓글을 등록 할 수 있습니다.
      </div>
    )}
    <div className="comment-list">
      {comments &&
        comments.map(comment => {
          return (
            <PartnerComment
              key={comment.id}
              id={comment.id}
              username={comment.user.username}
              thumbnail={comment.user.thumbnail}
              date={comment.created_at}
              comment={comment.text}
              replies={subCommentsMap[comment.id]}
              repliesCount={comment.replies_count}
              subCommentsMap={subCommentsMap}
              onReadReplies={onReadReplies}
              onReply={onReply}
              logged={logged}
              currentUsername={username}
              onOpenRemove={onOpenRemove}
              onEditComment={onEditComment}
            />
          );
        })}
    </div>
  </div>
);

export default PartnerComments;



// WEBPACK FOOTER //
// ./src/components/partner/PartnerComments/PartnerComments.js